<template>
  <v-container>
    <v-layout column
      v-for="(skillList, skillType) in skills"
      class="mt-3 mb-5"
      :key="skillType"
    >
      <h1 class="headline text-capitalize">{{ skillType }}</h1>
      <v-layout wrap row justify-center>
        <skill-icon v-for="skill in skillList"
          :key="skill"
          :skill="skill"
          :hover="isHover(skill)"
          @mouseover="active = skill"
          @mouseleave="active = ''"
        />
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import SkillIcon from '@/components/skills/SkillIcon.vue';
import skills from '@/assets/data/skills.json';
import groups from '@/assets/data/groups.json';

export default {
  components: {
    'skill-icon': SkillIcon,
  },
  data() {
    return {
      skills,
      groups,
      active: '',
    };
  },
  methods: {
    isHover(skill) {
      return skill === this.active || this.isGroup(skill);
    },
    isGroup(skill) {
      if (!(this.active in this.groups)) return false;
      return this.groups[this.active].indexOf(skill) >= 0;
    }
  },
};
</script>
